<template>
    <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle"
        :tip="`最多添加${maxCount}组图文，上传图片大小不超过2M（可拖动排序）`">
        <!-- 顺序设置 -->
        <ItemSetting label="图文顺序">
            <el-select v-model="value.order" placeholder="请选择顺序">
                <el-option label="先图后文" value="asc"></el-option>
                <el-option label="先文后图" value="desc"></el-option>
            </el-select>
        </ItemSetting>
        <!-- 图片设置 -->
        <ItemSetting label="图片宽(%)">
            <el-input type="number" placeholder="请输入图片宽度百分比" v-model.number="imageWidth"></el-input>
        </ItemSetting>
        <!-- 文字设置 -->
        <FontSetting v-model="font" />

        <vuedraggable v-if="data && data.length" v-model="data" tag="ul" draggable="li" class="item-list">
            <li v-for="(item, index) in data" :key="index">
                <ImageTextCard :title="`排序${index + 1}`" :index="index" v-model="data[index]" @remove-item="removeItem"
                    @edit-image="editImage" />
            </li>
        </vuedraggable>
        <EmptyCard v-else />

        <ButtonGroup>
            <UploadImage ref="imageUploader" :showUploadBtn="false" :disabled="data.length >= maxCount"
                @upload-success="updateImage" />
            <el-button type="primary" :disabled="data.length >= maxCount" icon="el-icon-plus"
                @click="addImageTextCard">添加图文组</el-button>
        </ButtonGroup>
    </EditBox>
</template>

<script>
import vuedraggable from 'vuedraggable'
import ImageTextCard from "./card/ImageTextCard";
import UploadImage from "@/components/Upload/UploadImage";
import EditBox from "./box/EditBox";
import FontSetting from "./setting/FontSetting";
import ItemSetting from "./setting/ItemSetting";
import EmptyCard from "./card/EmptyCard";
import ButtonGroup from "./btngroup/ButtonGroup";
import editMixin from './mixins/editMixin';

export default {
    name: 'ImageTextEdit',
    mixins: [editMixin],
    components: {
        vuedraggable,
        ImageTextCard,
        UploadImage,
        EditBox,
        FontSetting,
        ItemSetting,
        EmptyCard,
        ButtonGroup
    },
    props: {
        name: {
            type: String,
            default: () => ''
        },
        type: {
            type: String,
            default: () => ''
        },
        styleList: {
            type: Array,
            default: () => []
        },
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            maxCount: 4
        }
    },
    methods: {
        removeItem(index) {
            const newData = [...this.data]
            newData.splice(index, 1)
            this.updateValue({ data: newData })
        },
        editImage(index) {
            this.$refs.imageUploader.triggerUpload({ index })
        },
        updateImage(imgUrl, triggerParams) {
            const newData = [...this.data]
            if (triggerParams && triggerParams.index !== undefined) {
                newData[triggerParams.index] = { ...newData[triggerParams.index], url: imgUrl }
            } else {
                newData.push({ url: imgUrl, link: '', text: '' })
            }
            this.updateValue({ data: newData })
        },
        addImageTextCard() {
            const newData = [...this.data]
            newData.push({ url: '', link: '', text: '' })
            this.updateValue({ data: newData })
        }
    },
    computed: {
        font: {
            get() {
                return this.value.font
            },
            set(val) {
                this.updateValue({ font: val })
            }
        },
        imageWidth: {
            get() {
                return this.value.imageWidth
            },
            set(val) {
                if (!val) {
                    val = 0
                }
                if (val < 0 || val > 100) {
                    this.$message.error('图片宽度百分比必须在0-100之间')
                    return
                }
                this.updateValue({ imageWidth: val })
            }
        },
        data: {
            get() {
                return this.value.data || []
            },
            set(val) {
                this.updateValue({ data: val })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
